import type { IContact } from "@bbj-types/contact";
import type { ContactType } from "@bbj-types/contact/enum";
import { useCallback } from "react";
import { axiosEnterprise } from "./axios";

export interface TFindContactsQuery {
  search: string;
  type: ContactType;
}

export type TFindContactsResponse = IContact[];

export const useFindContacts = () => {
  const [state, execute, cancel] = axiosEnterprise<TFindContactsResponse, TFindContactsQuery, unknown>(
    {
      url: "/contacts",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (query: TFindContactsQuery) => {
      return execute({
        params: query,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
